import { db } from "./FirebaseService";
import { ref, get } from "firebase/database";

const VENDOR_ID = process.env.VUE_APP_VENDOR_ID;

export async function getSellerName() {
  const snapshot = await get(ref(db, `vendors/${VENDOR_ID}/name`));
  return snapshot.val();
}